import { styled } from '../jss-style';
import stickyStyle from './sticky';

const useStickyStyle = styled(stickyStyle, 'sticky');
export { stickyStyle, useStickyStyle };
export default useStickyStyle;
